import { handleAPIError } from "@services/Base";
import { useMutation } from "@tanstack/react-query";
import axios from "axios";
import { USER_API_URL } from "../../../config";
import { UserCreate, UserDetailed } from "../types";

export const useSaveUser = () => {
  return useMutation({
    mutationFn: (props: UserCreate) =>
      axios
        .post(`${USER_API_URL}/waves-user-manager-api/v1/users`, props, {})
        .then((response) => {
          return response.data as UserDetailed;
        })
        .catch((error) => {
          return handleAPIError(error);
        })
  });
};
